export default "__VITE_ASSET__kVpq_xoA__"